<template>
  <div ref="div" :class="className"></div>
</template>
<script setup lang="ts">
import qrcodeGenerator from "qrcode-generator";
const div = ref<HTMLDivElement>();

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: "",
  },
});

onMounted(() => {
  const qr = qrcodeGenerator(0, "L");
  qr.addData(props.value);
  qr.make();
  const img = qr.createImgTag(4);
  if (div.value) {
    div.value.innerHTML = img;
  }
});
</script>
